angular.module("warsApp").config(['blockUIConfig', function (blockUIConfig) {

    // Change the default overlay message
    blockUIConfig.message = 'Loading...';;
    

    // Otherwise the backspace key could be recognized during a autosave and more you back to 
    blockUIConfig.blockBrowserNavigation = true;

    // Change the default delay to 500ms before the blocking is visible
    blockUIConfig.delay = 500;

    blockUIConfig.requestFilter = function (config) {
        if (config.url.toLowerCase().endsWith('.html')) {
            return false;
        }

        if (config.url.match(/^\.\/security\/GetStaffByName($|\/).*/) ||
            config.url.match(/Users/) ||
            config.url.match(/\/Form\//) ||
            config.url.match(/Account/) ||
            config.url.match(/AutoComplete/) ||
            config.url.match(/CheckExistance/)) {
            return false; // ... don't block it.
        }

        return 'Loading...';
    };
}]);